<mat-toolbar class="sticky-sidebar">
    <button mat-icon-button (click)="toggleCollapse()" class="menu-hamburger side-menu-toggle">
        <mat-icon>menu</mat-icon>
    </button>
    <div class="container-fluid top-menu">
        <div class="row">

            <div class="col-md-4 mb-2 mb-md-0 d-flex align-items-center">
                <a class="navbar-brand" href="#">
                      <div class="otis-css-logo">
                        <span class="otis-logo"><img src = "assets/img/otis-logo.svg" alt="OTIS"/></span>
                        <span class="logo-pipe">|</span>   
                        <span class="logo-r2c">R2C</span>                     
                        <!-- <span class="ccc-logo"><img src = "assets/img/ccc.svg" alt="Cloud Contact Center"/></span> -->
                      </div>
                </a>
            </div>

            <div class="col-md-3 search-block d-inline-flex">
               
                <div class="search-box" *ngIf="callElevatorButtonEnable">
                    <input type="text" #call_elevator class="search-input txt-call-elevator"  [(ngModel)]="elevatorId" placeholder="Enter Elevator Number to Call" >
                    <button class="circle_dot top-bar-icon btn-call-elevator" [disabled]="!elevatorId" matTooltip="Elevator Call"  (click)="elevatorCallBack()" >
                        <mat-icon class="circle_dot_icon"> phone_in_talk </mat-icon>
                    </button>
                </div>
                <!-- <div class="phone_search-box"  *ngIf="phoneNumberButtonEnable">
                    <input type="text" #search_by_phone [(ngModel)]="phoneNumber" class="search-input txt-search-by-phone" placeholder="Phone Number">
                    <button (click)="searchByPhone()"  [disabled]="!phoneNumber" class="circle_dot top-bar-icon btn-search-by-phone" matTooltip="Click to search by phone number">
                        <mat-icon class="circle_dot_icon"> <img src = "assets/img/searching-by-phone.svg" alt="Cloud Contact Center"/> </mat-icon>
                    </button>
                </div> -->
                <!-- <div class="search-box" *ngIf="endOfAlarmButtonEnable">
                    <input type="text" #eoalarm_elevator ngClass="txt-eoa-elevatorId" [formControl]="eoaElevatorId" class="search-input" placeholder="Elevator ID">
                    <button class="circle_dot top-bar-icon eoa-button" color="accent" [disabled]="!eoaElevatorId.valid" (click)="endOfAlarm()" matTooltip="End Of Alarm">
                        <mat-icon class="circle_dot_icon"> directions_run </mat-icon>
                    </button>
                </div> -->
            </div>
            <div class="col-md-5 text-end mt-n5">

                <!-- For CCC only
                     <div class="status">
                    <div class="caller-online float-start">121</div>
                    <div class="caller-offline float-start">33</div>
                    <div class="caller-away float-start">98</div>
                </div> -->

                <!-- For CCC only
                    <div class="availability">
                    <div class="dot green float-start">&nbsp;</div>
                    <div class="Status-text float-start">Available</div>
                </div> -->
                <span class="otis-label" *ngIf="userStatusDisplay">Status</span>
                <div *ngIf="userStatusDisplay"                
                [ngClass]="(selectedAgentStatus.selectedStatus === 'Idle')?'agent-green-circle': (selectedAgentStatus.selectedStatus === 'Busy' || selectedAgentStatus.selectedStatus === 'Reserved')?'agent-red-circle':'agent-yellow-circle'">
              </div>
            <div class="top-bar-right">
                
                <!-- <span>Status:</span> 
                <div class="profile-status-label available"
                        class="{'profile-status-label': true, 'available': Idle == 'Idle', 'not-applicable': agent.selectedStatus == 'not-applicable', 'in-call': agent.selectedStatus == 'Reserved' || agent.selectedStatus == 'Busy', 'not-available': agent.selectedStatus == 'Offline'}"
                        ng-show="currentUser.roleId != 3 && currentUser.roleId != 4 && currentUser.roleId != 5">
                </div> -->
                <div class="country-dropdown">
                    <!-- agent login status -->
                    <select class="user-status-dropdown" *ngIf="userStatusDisplay"
                    [(ngModel)]="selectedAgentStatus.selectedStatus"
                    (change)="changeAgentStatus(selectedAgentStatus.selectedStatus, null, true)">
                    <option *ngIf="selectedAgentStatus.selectedStatus === undefined" [value]="undefined"
                        [selected]=true>{{selectedAgentStatus.selectedStatus=== undefined? 'Loading...': ''}}
                    </option>
                    <ng-container *ngFor="let statusVal of userStatus">
                        <option
                            *ngIf="(statusVal.sId !== '' && statusVal.display == undefined) || statusVal.status == selectedAgentStatus.selectedStatus"
                            [value]="statusVal.status">
                            {{statusjsondata[statusVal.status]}}
                        </option>
                    </ng-container>
                </select>
                    
                    <!-- <select class="user-status-dropdown" *ngIf="userStatusDisplay"
                            [(ngModel)]="selectedAgentStatus.selectedStatus"
                            (change)="changeAgentStatus(selectedAgentStatus.selectedStatus, null, true)">
                            <option *ngIf="selectedAgentStatus.selectedStatus === undefined" [value]="undefined"
                                [selected]=true>{{selectedAgentStatus.selectedStatus=== undefined? 'Loading...': ''}}
                            </option>
                            <ng-container *ngFor="let statusVal of userStatus">
                                <option *ngIf="selectedAgentStatus.selectedStatus !==undefined"
                                    [hidden]="statusVal.sId == ''" [value]="statusVal.status">
                                    {{statusVal.status}}
                                </option>
                            </ng-container>
                             {{statusjsondata[statusVal.status]}}
                        </select> -->

                    <select [(ngModel)]="selectedCountry" (change)="setLocalization('country')" *ngIf="rolePagePermission.includes('countryList')">
                        <option *ngFor="let country of countries" [value]="country.id">
                            {{country.value}} 
                        </option>
                    </select>
                    <select [(ngModel)]="selectedLanguage" (change)="setLocalization('language')">
                        <option *ngFor="let language of languages" [value]="language.code">
                            {{language.name}} 
                        </option>
                    </select>
                </div>
                <div class="users-icon">
                    <button class="user-dropdown" mat-mini-fab color="success" [matMenuTriggerFor]="userAccountMenu">
                       <!-- <mat-icon class="avatar_css">account_circle</mat-icon>-->
                        <mat-icon class="avatar_circle">manage_accounts</mat-icon>
                    </button>
                    <mat-menu #userAccountMenu [overlapTrigger]="false" yPosition="below">
                        <button mat-menu-item (click)="userProfileDialog()" *ngIf="userType === 1">
                          <mat-icon>person</mat-icon><span>{{'menu.userProfile' | localize }}</span>
                        </button>

                        <button mat-menu-item (click)="changePasswordDialog()">
                            <mat-icon>person</mat-icon><span>{{'menu.changePassword' | localize }}</span>
                        </button>
                        <button mat-menu-item (click)="aboutDialog()">
                            <mat-icon>help</mat-icon><span>{{'menu.about' | localize }}</span>
                        </button>
                        <mat-divider></mat-divider>
                        <button mat-menu-item routerLink="#" (click)="logout()">
                            <mat-icon>exit_to_app</mat-icon>{{'menu.logout' | localize }}
                        </button>
                    </mat-menu>
                </div>
            </div>
            </div>
        </div>
    </div>

</mat-toolbar>


<div class="body" [ngClass]="getBodyClass()">

    <div class="sidenav" [ngClass]="collapsed ? 'sidenav-collapsed': ''" (mouseenter)="collapsed = true"
        (mouseleave)="collapsed = false">
        <div class="scrollwrap scrollwrap_delayed">
            <ul class="sidenav-nav">
                <ng-container *ngFor="let data of navData">
                    <li class="sidenav-nav-item" *ngIf= "data.link"  >
                        <a class="sidenav-nav-link" (click)="handleClick(data)" *ngIf="(data.menu && data.menu.length > 0)"
                            [ngClass]="getActiveClass(data)">
                            <mat-icon class="sidenav-link-icon">{{data.icon}}</mat-icon>
                            <span class="sidenav-link-text" @fadeInOut *ngIf="collapsed">
                                {{'menu.'+data.text  | localize }}
                            </span>
                            <em *ngIf="data.menu && collapsed" class="menu-collapse-icon"
                                [ngClass]="!data.expanded ? 'fal fa-angle-right' : 'fal fa-angle-down'"></em>
                        </a>

                        <a class="sidenav-nav-link" *ngIf="(!data.menu && data.link.length != 0  ) || ((data.menu && data.link.length != 0 ) && data.menu.length === 0)"
                            [routerLink]="[data.link]" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                            (click)="shrinkItems(data)">
                            <mat-icon class="sidenav-link-icon">{{data.icon}}</mat-icon>
                            <span class="sidenav-link-text" @fadeInOut *ngIf="collapsed">
                                {{'menu.'+data.text  | localize}}
                            </span>
                        </a>
                        <div *ngIf="collapsed && data.menu && data.menu.length > 0">
                            <app-sublevel-menu [data]="data" [collapsed]="collapsed" [multiple]="multiple"
                                [expanded]="data.expanded"></app-sublevel-menu>
                        </div>
                    </li>
                </ng-container>
            </ul>
        </div>
    </div>

    <div class="content-container container-fluid">
        <div class="row pt-1 ps-1">
            <div class="col p-2 pe-0">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
    <div class="footer-bottom"><app-footer></app-footer></div>
</div>
